import React from 'react';
import {
  AnimatedSkeletonLoaderProps,
  AnimatedSkeletonLoader as BaseAnimatedSkeletonLoader,
} from '@usepepper/ui/atoms/animated-skeleton-loader';
import { createStyles } from '@/contexts/theme-context';

export const AnimatedSkeletonLoader: React.FC<AnimatedSkeletonLoaderProps> = ({
  ...animatedSkeletonLoaderProps
}) => {
  const [styles] = useStyles();

  return (
    <BaseAnimatedSkeletonLoader
      style={styles.container}
      {...animatedSkeletonLoaderProps}
    />
  );
};

const useStyles = createStyles(() => ({
  container: {
    marginTop: 4,
  },
}));
